import { SET_ACTIVE_BOOTH_FILE, RESET } from '../actions/main';

const LEAVE_MSG = 'You have unsaved changes on your floor map. Leave without saving?';

const hasUnsavedChanges = (state) => state.booth_history?.past?.length > 1;

/** Intercepts map reset/switch when undo history indicates unsaved edits. */
const unsavedMapGuardMiddleware = (store) => (next) => (action) => {
  const state = store.getState();
  if (!hasUnsavedChanges(state) || state.main?.active_booth_file?.overview) {
    return next(action);
  }

  const switchingMap =
    action.type === SET_ACTIVE_BOOTH_FILE &&
    action.payload?.KEY_ID &&
    state.main?.active_booth_file?.KEY_ID &&
    action.payload.KEY_ID !== state.main.active_booth_file.KEY_ID;

  if (action.type !== RESET && !switchingMap) {
    return next(action);
  }

  if (!window.confirm(LEAVE_MSG)) {
    return { type: '@@unsavedMapGuard/BLOCKED' };
  }

  return next(action);
};

export default unsavedMapGuardMiddleware;
